var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"about-footer-menu"},[_c('BaseLink',{staticClass:"footer-link",attrs:{"to":{ name: 'about/privacy' }}},[_vm._v(" Privacy Policy ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }